import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Dropdown,
  Button,
  Input,
  FormGroup,
  FormField,
  Icon,
  Checkbox,
  Form
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardDrugOrderUX = (props: any) => {
    return(
      <div
        id="CardDrugOrderUX-div-0"
        style={{ position: "relative" }}>
        <div
          id="CardDrugOrderUX-div-70"
          style={{ position: "relative", padding: "5px", ...( props.hiddenDrugList ? {display: "none"} : {display: "block"}) }}>
          
          <div
            id="CardDrugOrderUX-div-73"
            style={{display: "flex", alignItems: "center"}}>
            
            <div
              id="CardDrugOrderUX-div-72"
              style={{ fontSize: "1.2rem", fontWeight: "bold", marginBottom: "0rem"}}>
              {props.languageUX === "en" ? "Prescription Detail" : "รายการใบยา"}
            </div>
            <label
              id="CardDrugOrderUX-label-248"
              style={{fontSize: "1.2rem", margin:"0rem 1rem 0.025rem 2rem"}}>
              {props.languageUX === "en" ? "Date" : "วันที่"}
            </label>
            <div
              className="ui form size mini"
              id="CardDrugOrderUX-div-239"
              style={{display: "flex", alignItems: "baseline", fontSize: ""}}>
              
              <div
                id="CardDrugOrderUX-div-244"
                style={{cursor: "pointer"}}>
                
                <Button
                  circular={true}
                  color="teal"
                  icon={true}
                  id="CardDrugOrderUX-Button-249"
                  onClick={()=>props.onChangeFilterCreateDate?.({type: "prev"})}
                  size="mini">
                  <Icon
                    id="CardDrugOrderUX-Icon-246"
                    name="angle double left">
                  </Icon>
                </Button>
              </div>
              <DateTextBox
                id="CardDrugOrderUX-DateTextBox-241"
                onChange={(date)=>props.onChangeFilterCreateDate?.({date})}
                value={props.filterCreateDate}>
              </DateTextBox>
              <div
                id="CardDrugOrderUX-div-245"
                style={{cursor: "pointer", marginLeft: "0.25em"}}>
                
                <Button
                  circular={true}
                  color="teal"
                  icon={true}
                  id="CardDrugOrderUX-Button-250"
                  onClick={()=>props.onChangeFilterCreateDate?.({type: "next"})}
                  size="mini">
                  <Icon
                    id="CardDrugOrderUX-Icon-247"
                    name="angle double right">
                  </Icon>
                </Button>
              </div>
            </div>
            <div
              id="CardDrugOrderUX-div-251">
              {props.helperLabel}
            </div>
            <div
              id="CardDrugOrderUX-div-74"
              style={{flex: 1}}>
              
            </div>
            <Button
              color="yellow"
              id="CardDrugOrderUX-Button-175"
              loading={props.loadingStatus?.PRINT_NARCOTIC_FORM}
              onClick={props.onPrintNarcotic}
              size="small"
              style={{display: props.isShowNarcoticPrint ? "" : "none"}}>
              {props.languageUX === "en" ? "Print the form." : "พิมพ์ใบ ยส."}
            </Button>
            <Button
              color="yellow"
              id="CardDrugOrderUX-Button-176"
              loading={props.loadingStatus?.PRINT_PSYCHOTROPIC_FORM}
              onClick={props.onPrintPsychotropic}
              size="small"
              style={{display: props.isShowPsychotropicPrint? "" : "none"}}>
              {props.languageUX === "en" ? "Print the order to dispense the active substance" : "พิมพ์สั่งจ่ายวัตถุออกฤทธิ์"}
            </Button>
            <Button
              color="yellow"
              disabled={props.disabledPrintDrugOrderBtn}
              icon={true}
              id="CardDrugOrderUX-Button-171"
              labelPosition="left"
              onClick={props.onPrintDrugOrder}
              size="small">
              <Icon
                id="CardDrugOrderUX-Icon-172"
                name="print">
              </Icon>
              <label
                id="CardDrugOrderUX-label-174">
                {props.languageUX === "en" ? "Print prescription" : "พิมพ์ใบสั่งยา"}
              </label>
            </Button>
            <Button
              color="green"
              disabled={props.disabledAddDrugOrderBtn}
              id="btn-addMedOrder"
              onClick={props.addNewOrder}
              size="small">
              {props.languageUX === "en" ? "Add a new prescription" : "เพิ่มใบยา"}
            </Button>
          </div>
          <Table
            NoDataComponent={props.noDataComponent}
            className="--rt-tbody-overflow-y-hidden"
            data={props.drugOrderList}
            getTdProps={props.listRowProps}
            headers="Code, Created,Status,Summary,Careprovider,Del, Edit"
            id="tb-medOrderList"
            keys="code,created,status,summary,careprovider,delete,edit"
            minRows={props.minRows ? props.minRows : 6}
            showPagination={false}
            style={props.styleDrugOrderTable}
            widths="^90,^110,115,^310,^150,^75,^75">
          </Table>
          <div
            id="CardDrugOrderUX-div-192">
            {props.loader}
          </div>
        </div>
        <div
          id="CardDrugOrderUX-div-2"
          style={{display:  props.statusRequest ? "grid" : "none",    gridTemplateColumns: "repeat(9, minmax(0, 1fr))", padding: "5px",}}>
          
          <div
            id="CardDrugOrderUX-div-76"
            style={{ gridColumn: "1/10"}}>
            {props.ErrorMessage}
          </div>
          <div
            id="CardDrugOrderUX-div-90"
            style={{ gridColumn: "1/10", fontWeight: "bold" ,display:"flex" , fontSize: "1.2rem", margin: "20px 0px"}}>
            
            <div
              id="CardDrugOrderUX-div-91"
              style={{ marginRight: "20px " }}>
              {props?.orderStatus}
            </div>
            <div
              id="CardDrugOrderUX-div-92">
              {props?.orderName}
            </div>
            <div
              id="CardDrugOrderUX-div-184"
              style={{ fontSize: "14px" }}>
              {props?.approveStatus}
            </div>
            <div
              id="CardDrugOrderUX-div-187"
              style={{flex:1}}>
              
            </div>
            <div
              className="ui form --override-disabled --grey"
              id="CardDrugOrderUX-div-188"
              style={{display:  props.showTelepharType?"flex":"none"}}>
              {}
              <Checkbox
                checked={props.telepharType=== "DELIVERY"}
                className="blue"
                disabled={props.hasDrugTransportNotAllowed}
                id="CardDrugOrderUX-Checkbox-189"
                label={props.languageUX === "en" ? "Home delivery" : "บริการส่งถึงบ้าน"}
                name="DELIVERY"
                onChange={props.onChangeTelepharType}
                style={{fontWeight: "normal"}}>
              </Checkbox>
              <Checkbox
                checked={props.telepharType=== "INTRA"}
                className="blue"
                id="CardDrugOrderUX-Checkbox-190"
                label={props.languageUX === "en" ? "Intrahospital Telepharmacy" : "เภสัชกรรมทางไกลภายในโรงพยาบาล"}
                name="INTRA"
                onChange={props.onChangeTelepharType}
                style={{fontWeight: "normal", margin: "0 1rem"}}>
              </Checkbox>
            </div>
          </div>
          <div
            className="ui form"
            id="CardDrugOrderUX-div-193"
            style={{gridColumn: "1/10", paddingLeft: "1rem", marginTop: "-0.5rem", display: "none"}}>
            
            <FormGroup
              id="CardDrugOrderUX-FormGroup-194">
              <FormField
                id="CardDrugOrderUX-FormField-195"
                style={{paddingLeft:0}}
                width={6}>
                <FormField
                  className="required"
                  id="CardDrugOrderUX-FormField-225">
                  <label
                    id="CardDrugOrderUX-label-226"
                    style={{margin:0}}>
                    {props.languageUX === "en" ? "Drug" : "ยา"}
                  </label>
                </FormField>
                <div
                  id="CardDrugOrderUX-div-199"
                  style={{width: "100%"}}>
                  {props.DrugSearchBox}
                </div>
              </FormField>
              <FormField
                id="CardDrugOrderUX-FormField-196"
                style={{paddingLeft:0}}>
                <label
                  id="CardDrugOrderUX-label-200"
                  style={{margin:0}}>
                  {"\u00a0"}
                </label>
                <Button
                  color={props.hasFactSheet ? "blue" : undefined}
                  disabled={!props.hasFactSheet}
                  fluid={true}
                  id="CardDrugOrderUX-Button-201"
                  onClick={props.openFactSheet}
                  style={{ whiteSpace: "nowrap"}}>
                  {props.languageUX === "en" ? "DRUG FACT" : "ข้อเท็จจริงเกี่ยวกับยาเสพติด"}
                </Button>
              </FormField>
              <FormField
                id="CardDrugOrderUX-FormField-227"
                style={{paddingLeft:0}}>
                <label
                  id="CardDrugOrderUX-label-228"
                  style={{margin:0}}>
                  {"\u00a0"}
                </label>
                <div
                  id="CardDrugOrderUX-div-231">
                  {props.calculatorIcon}
                </div>
              </FormField>
              <FormField
                id="CardDrugOrderUX-FormField-197"
                style={{paddingLeft:0}}
                width={2}>
                <label
                  id="CardDrugOrderUX-label-202"
                  style={{margin:0}}>
                  {props.languageUX === "en" ? "PRN" : "PRN"}
                </label>
                <Input
                  disabled={!props.selectedDrug }
                  fluid={true}
                  id="CardDrugOrderUX-Input-203"
                  onChange={props.ChangeDrugPrn}
                  value={props.drugPrn? props.drugPrn : ""}>
                </Input>
              </FormField>
              <FormField
                id="CardDrugOrderUX-FormField-204"
                style={{ display: props.drugPermission?.config_TPD_ENABLE_IV_COMPATIBLE ? "" : "none",paddingLeft:0}}>
                <label
                  id="CardDrugOrderUX-label-206"
                  style={{margin:0}}>
                  {"\u00a0"}
                </label>
                <Button
                  disabled={!props.modSolventSelectionConfig?.showButtonSolvent }
                  fluid={true}
                  id="CardDrugOrderUX-Button-232"
                  onClick={props.onOpenModSolventSelection}>
                  {props.languageUX === "en" ? "solvent" : "ตัวทำละลาย"}
                </Button>
              </FormField>
              <FormField
                id="CardDrugOrderUX-FormField-214"
                style={{display: props.selectedDrug?.original?.is_taper_dose ? "": "none",  fontWeight: "bold",paddingLeft:0 }}>
                <label
                  id="CardDrugOrderUX-label-217"
                  style={{margin:0}}>
                  {"\u00a0"}
                </label>
                <div
                  id="CardDrugOrderUX-div-221">
                  {props.buttonTaperSchedule}
                </div>
              </FormField>
              <FormField
                id="CardDrugOrderUX-FormField-215"
                style={{flex:1}}>
              </FormField>
              <FormField
                id="CardDrugOrderUX-FormField-222"
                style={{ display: props.drugPermission?.config_TPD_ENABLE_PTC_DISPENSE  ? "" : "none",paddingLeft:0}}>
                <label
                  id="CardDrugOrderUX-label-224"
                  style={{margin:0}}>
                  {"\u00a0"}
                </label>
                <Button
                  color="blue"
                  disabled={!props.enabledButtonDispense}
                  id="CardDrugOrderUX-Button-223"
                  onClick={props.onClickDispense}>
                  {props.languageUX === "en" ? "Drug distribution" : "ยาแบ่งจ่าย"}
                </Button>
              </FormField>
              <FormField
                id="CardDrugOrderUX-FormField-216"
                style={{paddingLeft:0}}>
                <label
                  id="CardDrugOrderUX-label-218"
                  style={{margin:0}}>
                  {"\u00a0"}
                </label>
                <Button
                  disabled={props.statusRequest ? false : true}
                  icon="file"
                  id="CardDrugOrderUX-Button-219"
                  onClick={props.clearDrugOrderForm}>
                </Button>
              </FormField>
            </FormGroup>
          </div>
          <div
            className="ui form"
            id="CardDrugOrderUX-div-93"
            style={{gridColumn: "1/10", paddingLeft: "1rem", marginTop: "-0.25rem", display: "none"}}>
            
            <FormGroup
              id="CardDrugOrderUX-FormGroup-94">
              <FormField
                className={`required noPadding${props.errorMessage &&!props.drugDose  ? " error" :""}${props.hideDrugForm?.dose ? " hidden": ""}`}
                id="CardDrugOrderUX-FormField-95"
                style={{paddingLeft:0}}
                width={2}>
                <label
                  id="CardDrugOrderUX-label-96"
                  style={{margin:0}}>
                  {props.languageUX === "en" ? "Dose" : "ปริมาณยา"}
                </label>
                <div
                  id="CardDrugOrderUX-div-238">
                  {props.doseInput}
                </div>
              </FormField>
              <FormField
                className={`required noPadding${props.errorMessage &&!props.selectedDrugUnitId ? " error" :""}${props.hideDrugForm?.unit ? " hidden": ""}`}
                id="CardDrugOrderUX-FormField-98"
                style={{paddingLeft:0}}
                width={2}>
                <label
                  id="CardDrugOrderUX-label-106"
                  style={{margin:0}}>
                  {props.languageUX === "en" ? "Unit" : "หน่วย"}
                </label>
                <Dropdown
                  className="inline-label"
                  disabled={!props.selectedDrug}
                  fluid={true}
                  id="cb-drugUnit"
                  onChange={props.changeDrugUnit}
                  options={props.drugUnits}
                  search={true}
                  selection={true}
                  value={props.selectedDrugUnitId}>
                </Dropdown>
              </FormField>
              <FormField
                className={`required noPadding${props.errorMessage &&!props.selectedDrugRouteId ? " error" :""}${props.hideDrugForm?.route ? " hidden": ""}`}
                id="CardDrugOrderUX-FormField-99"
                style={{paddingLeft:0}}
                width={2}>
                <label
                  id="CardDrugOrderUX-label-107"
                  style={{margin:0}}>
                  {props.languageUX === "en" ? "Route" : "ช่องทาง"}
                </label>
                <Dropdown
                  className="inline-label"
                  disabled={!props.selectedDrug}
                  fluid={true}
                  id="cb-drugRoute"
                  onChange={props.changeDrugRoute}
                  options={props.drugRoutes}
                  search={true}
                  selection={true}
                  value={props.selectedDrugRouteId}>
                </Dropdown>
              </FormField>
              <FormField
                className={`required noPadding${props.errorMessage &&!props.selectedDrugSiteId? " error" :"" }${props.hideDrugForm?.site ? " hidden": ""}`}
                id="CardDrugOrderUX-FormField-100"
                style={{paddingLeft:0}}
                width={2}>
                <label
                  id="CardDrugOrderUX-label-108"
                  style={{margin:0}}>
                  {props.languageUX === "en" ? "Site" : "ตำแหน่ง"}
                </label>
                <Dropdown
                  className="inline-label"
                  disabled={!props.selectedDrug}
                  fluid={true}
                  id="cb-drugSite"
                  onChange={props.changeDrugSite}
                  options={props.drugSites}
                  search={true}
                  selection={true}
                  value={props.selectedDrugSiteId}>
                </Dropdown>
              </FormField>
              <FormField
                className={`required noPadding${props.errorMessage &&!props.selectedDrugFrequencyId? " error" :"" }${props.hideDrugForm?.frequency ? " hidden": ""}`}
                id="CardDrugOrderUX-FormField-101"
                style={{paddingLeft:0}}
                width={2}>
                <label
                  id="CardDrugOrderUX-label-109"
                  style={{margin:0}}>
                  {props.languageUX === "en" ? "Frequency" : "ความถี่"}
                </label>
                <Dropdown
                  className="inline-label"
                  disabled={!props.selectedDrug}
                  fluid={true}
                  id="cb-drugFrequency"
                  onChange={props.changeDrugFrequency}
                  options={props.drugFrequencies}
                  search={true}
                  selection={true}
                  value={props.selectedDrugFrequencyId}>
                </Dropdown>
              </FormField>
              <FormField
                className={`required noPadding${props.hideDrugForm?.method ? " hidden": ""}`}
                id="CardDrugOrderUX-FormField-102"
                style={{paddingLeft:0}}
                width={2}>
                <label
                  id="CardDrugOrderUX-label-110"
                  style={{margin:0}}>
                  {props.languageUX === "en" ? "Method" : "วิธี"}
                </label>
                <Dropdown
                  className="inline-label"
                  disabled={!props.selectedDrug}
                  fluid={true}
                  id="cb-drugMedthod"
                  onChange={props.changeDrugMethod}
                  options={props.drugMethods}
                  search={true}
                  selection={true}
                  value={props.selectedDrugMethodId}>
                </Dropdown>
              </FormField>
              <FormField
                className={`required noPadding${props.errorMessage &&!props.drugQty? " error" :""}`}
                id="CardDrugOrderUX-FormField-103"
                style={{paddingLeft:0}}
                width={2}>
                <label
                  id="CardDrugOrderUX-label-111"
                  style={{margin:0}}>
                  {props.languageUX === "en" ? "Qty" : "จำนวน"}
                </label>
                <Input
                  disabled={!props.selectedDrug}
                  fluid={true}
                  id="txt-drugQty"
                  onChange={props.changeDrugQty}
                  style={{opacity: 1}}
                  value={props.drugQty ? props.drugQty : ""}>
                </Input>
              </FormField>
              <FormField
                className={`${props.noRequiredDuration ? "":"required "}noPadding${props.hideDrugForm?.duration ? " hidden": ""}`}
                id="CardDrugOrderUX-FormField-104"
                style={{paddingLeft:0}}
                width={2}>
                <label
                  id="CardDrugOrderUX-label-112"
                  style={{margin:0}}>
                  {props.languageUX === "en" ? "Duration (day)" : "ระยะเวลา (วัน)"}
                </label>
                <Input
                  disabled={!props.selectedDrug}
                  fluid={true}
                  id="txt-drugDuration"
                  onChange={props.changeDrugDuration}
                  readOnly={props.readOnlyDuration || false}
                  style={{opacity: 1}}
                  value={props.drugDuration ? props.drugDuration: ""}>
                </Input>
              </FormField>
              <div
                className="field  noPadding"
                id="CardDrugOrderUX-div-121"
                style={{flex: props.drugFormFlexStyle ? 1 : ""}}>
                
              </div>
              <FormField
                id="CardDrugOrderUX-FormField-105">
                <Button
                  color="green"
                  disabled={props.statusRequest ? false : true}
                  fluid={true}
                  id="btn-addMedOrder"
                  onClick={props.addToOrder}
                  style={{marginTop: "20.5px", width: "150px"}}>
                  {props.languageUX === "en" ? "ADD TO ORDER" : "เพิ่มลงในคำสั่งซื้อ"}
                </Button>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardDrugOrderUX-FormGroup-177"
              style={{ display: props.hideDrugDescription ? "none" : ""}}>
              <FormField
                id="CardDrugOrderUX-FormField-178"
                style={{padding: 0, marginTop: "-0.5rem"}}
                width={Object.values({...(props.hideDrugForm || {}),qty:false}).reduce((r,v)=>r+=(!!v ? 0 : 2),0)}>
                <label
                  id="CardDrugOrderUX-label-179"
                  style={{margin:0}}>
                  {props.languageUX === "en" ? "Description" : "คำอธิบาย"}
                </label>
                <Input
                  disabled={!props.selectedDrug}
                  fluid={true}
                  id="txt-drugDescription"
                  onChange={props.changeDrugDescription}
                  style={{opacity: 1}}
                  value={props.drugDescription || ""}>
                </Input>
              </FormField>
            </FormGroup>
            <div
              id="CardDrugOrderUX-div-236">
              {props.pediatricWarning}
            </div>
          </div>
          <div
            id="CardDrugOrderUX-div-252"
            style={{gridColumn: "1/10", marginTop: "-1rem"}}>
            {props.cardEditMedOrder}
          </div>
        </div>
        <div
          id="CardDrugOrderUX-div-4"
          style={{ display: props.statusRequest ? "" : "none", padding: "5px"}}>
          
          <Table
            className="--rt-tbody-overflow-y-hidden"
            data={props.drugOrderItems}
            getTrProps={props.drugItemsTrProps}
            headers="Drug,Dose,Unit,Route,Site,Frequency,PRN,QTY,Duration,Price/Unit,Total Price,"
            id="tb-medicationList"
            keys="title_status,dose,unit,route,site,frequency,prn,quantity,duration,price_unit,price_total,_remove"
            minRows="8"
            showPagination={false}
            style={{  height: "325px",display: "none" }}
            widths="^110,^60,^90,^90,^90,^115,^60,^60,^70,^80,^75,^50">
          </Table>
          <div
            id="CardDrugOrderUX-div-253">
            {props.tableElement}
          </div>
        </div>
        <div
          id="CardDrugOrderUX-div-254"
          style={{ display: !props.hideCardDrugVerbalOrder && props.statusRequest ? "" : "none" }}>
          {props.componentDrugVerbalOrder}
        </div>
        <div
          id="CardDrugOrderUX-div-3"
          style={{ display: "none"  }}>
          
          <div
            id="CardDrugOrderUX-div-40"
            style={{"height": "110px", "display": "grid", "gridTemplateRows": "10.638297872340425% 5.319148936170213% 4.25531914893617% 2.127659574468085% 3.1914893617021276% 3.1914893617021276% 2.127659574468085% 2.127659574468085% 3.1914893617021276% 8.51063829787234% 5.319148936170213% 2.127659574468085% 9.574468085106384% 1.0638297872340425% 1.0638297872340425% 7.446808510638298% 1.0638297872340425% 1.0638297872340425% 2.127659574468085% 6.382978723404255% 2.127659574468085% 15.957446808510639%", "gridTemplateColumns": "0.5198180636777128% 1.949317738791423% 2.2092267706302793% 2.079272254710851% 0.8447043534762833% 6.562703053931124% 0.3898635477582846% 3.833658219623132% 37.10201429499675% 0.9746588693957114% 3.5737491877842755% 0.8447043534762833% 0.3898635477582846% 3.248862897985705% 3.378817413905133% 0.9746588693957114% 4.028589993502274% 0.9096816114359974% 0.3248862897985705% 2.3391812865497075% 3.898635477582846% 0.9746588693957114% 5.003248862897986% 4.158544509421702% 0.3248862897985705% 3.248862897985705% 3.898635477582846% 0.4548408057179987% 0.5847953216374269% 0.9746588693957114%"}}>
            <div
              id="CardDrugOrderUX-div-41"
              style={{"gridRow": "2/11", "gridColumn": "5/30",  "width": "100%", "height": "100%"}}>
              
              <Dropdown
                id="CardDrugOrderUX-Dropdown-55"
                onChange={props.onChangeDivision}
                options={props.divisionOptions}
                selection={true}
                style={{ width: "100%" , height: "100%"}}
                value={props.orderDiv}>
              </Dropdown>
            </div>
            <div
              id="CardDrugOrderUX-div-44"
              style={{"gridRow": "6/7", "gridColumn": "28/29", "border": "solid black 1px", "width": "100%", "height": "100%"}}>
              {props.languageUX === "en" ? "x" : "x"}
            </div>
            <div
              id="CardDrugOrderUX-div-45"
              style={{"gridRow": "3/8", "gridColumn": "2/4", "width": "100%", "height": "100%"}}>
              {props.languageUX === "en" ? "Ordering department" : "แผนกที่สั่ง"}
            </div>
            <div
              id="CardDrugOrderUX-div-46"
              style={{"gridRow": "12/22", "gridColumn": "5/10", "width": "100%", "height": "100%"}}>
              
              <Input
                id="txt-notetoPharmacy"
                onChange={props.onChangeDoctorNote}
                style={{ width: "100%" }}
                value={props.doctorNote}>
              </Input>
            </div>
            <div
              id="CardDrugOrderUX-div-47"
              style={{"gridRow": "13/21", "gridColumn": "11/16", "width": "100%", "height": "100%"}}>
              
              <Button
                disabled={props.statusRequest ? false : true}
                id="btn-remed"
                onClick={props.onClickREMED}
                style={{ width: "100%", display: "none" }}>
                {props.languageUX === "en" ? "REMED" : "ได้รับการแก้ไขแล้ว"}
              </Button>
              <Button
                color="blue"
                disabled={props.statusRequest ? false : true}
                id="CardDrugOrderUX-Button-122"
                onClick={props.onClickDrugHistory}
                style={{width: "100%"}}>
                {props.languageUX === "en" ? "Drug History" : "ประวัติการใช้ยา"}
              </Button>
            </div>
            <div
              id="CardDrugOrderUX-div-50"
              style={{"gridRow": "14/17", "gridColumn": "2/3", "width": "100%", "height": "100%"}}>
              {props.languageUX === "en" ? "Note" : "บันทึก"}
            </div>
            <div
              id="CardDrugOrderUX-div-51"
              style={{"gridRow": "13/21", "gridColumn": "17/22", "width": "100%", "height": "100%"}}>
              
              <Button
                disabled={props.statusRequest ? false : true}
                id="btn-medSet"
                onClick={props.onClickOrderset}
                style={{ width: "100%" }}>
                {props.languageUX === "en" ? "Medical kit" : "ชุดยา"}
              </Button>
            </div>
            <div
              id="CardDrugOrderUX-div-54"
              style={{"gridRow": "13/21", "gridColumn": "23/30", "width": "100%", "height": "100%"}}>
              
              <Button
                color="green"
                disabled={props.statusRequest ? false : true}
                id="btn-confirmMedOrder"
                onClick={props.confirmOrder}
                style={{ width: "100%", ...(props.disabledConfirmedOrderBtn && {display: "none"})}}>
                {props.languageUX === "en" ? "CONFIRM ORDER" : "ยืนยันการสั่งซื้อ"}
              </Button>
            </div>
          </div>
        </div>
        <div
          id="CardDrugOrderUX-div-123"
          style={{ display: props.statusRequest ? "" : "none"  }}>
          
          <div
            id="CardDrugOrderUX-div-255"
            style={{padding: "10px"}}>
            
            <Form
              id="CardDrugOrderUX-Form-256">
              <FormGroup
                className="--override-disabled --grey"
                id="CardDrugOrderUX-FormGroup-257">
                <FormField
                  id="CardDrugOrderUX-FormField-280"
                  style={{ width: "100%" }}>
                </FormField>
                <FormField
                  id="CardDrugOrderUX-FormField-258"
                  inline={true}
                  style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                  width={3}>
                  <div
                    id="CardDrugOrderUX-div-274">
                    
                    <label
                      id="CardDrugOrderUX-label-277">
                      {props.languageUX === "en" ? "Total price" : "ราคารวม"}
                    </label>
                  </div>
                </FormField>
                <FormField
                  id="CardDrugOrderUX-FormField-259"
                  inline={true}
                  width={6}>
                  <div
                    id="CardDrugOrderUX-div-266"
                    style={{ width: "100%" }}>
                    
                    <Input
                      disabled={true}
                      fluid={true}
                      id="CardDrugOrderUX-Input-271"
                      value={props.priceTotal}>
                    </Input>
                  </div>
                </FormField>
                <FormField
                  id="CardDrugOrderUX-FormField-260"
                  inline={true}
                  style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                  width={3}>
                  <div
                    id="CardDrugOrderUX-div-275">
                    
                    <label
                      id="CardDrugOrderUX-label-278">
                      {props.languageUX === "en" ? "Claimable" : "เบิกได้"}
                    </label>
                  </div>
                </FormField>
                <FormField
                  id="CardDrugOrderUX-FormField-261"
                  inline={true}
                  width={6}>
                  <div
                    id="CardDrugOrderUX-div-265"
                    style={{ width: "100%" }}>
                    
                    <Input
                      disabled={true}
                      fluid={true}
                      id="CardDrugOrderUX-Input-272"
                      value={props.priceClaimable}>
                    </Input>
                  </div>
                </FormField>
                <FormField
                  id="CardDrugOrderUX-FormField-262"
                  inline={true}
                  style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                  width={3}>
                  <div
                    id="CardDrugOrderUX-div-276">
                    
                    <label
                      id="CardDrugOrderUX-label-279">
                      {props.languageUX === "en" ? "Non Claimable" : "เบิกไม่ได้"}
                    </label>
                  </div>
                </FormField>
                <FormField
                  id="CardDrugOrderUX-FormField-263"
                  inline={true}
                  width={6}>
                  <div
                    id="CardDrugOrderUX-div-264"
                    style={{ width: "100%" }}>
                    
                    <Input
                      disabled={true}
                      fluid={true}
                      id="CardDrugOrderUX-Input-273"
                      value={props.priceNonClaimable}>
                    </Input>
                  </div>
                </FormField>
              </FormGroup>
            </Form>
          </div>
          <div
            className="ui form"
            style={{padding: "10px"}}>
            
            <FormGroup
              id="CardDrugOrderUX-FormGroup-140"
              inline={true}>
              <FormField
                id="CardDrugOrderUX-FormField-142"
                inline={true}>
                <div
                  id="CardDrugOrderUX-div-152"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Ordering department" : "แผนกที่สั่ง"}
                </div>
              </FormField>
              <FormField
                id="CardDrugOrderUX-FormField-143"
                inline={true}
                width={(props.roleTypes || []).includes("DOCTOR") ? 15 : 7}>
                <div
                  id="CardDrugOrderUX-div-150"
                  style={{"width": "100%", "height": "100%"}}>
                  
                  <Dropdown
                    id="CardDrugOrderUX-Dropdown-151"
                    onChange={props.onChangeDivision}
                    options={props.divisionOptions}
                    search={true}
                    selection={true}
                    style={{ width: "100%" , height: "100%"}}
                    value={props.orderDiv}>
                  </Dropdown>
                </div>
              </FormField>
              <FormField
                id="CardDrugOrderUX-FormField-164"
                inline={true}
                style={{ display: props.hideCardDrugVerbalOrder ? "" : "none" }}
                width={(props.roleTypes || []).includes("DOCTOR") ? 0 : 1}>
                <div
                  id="CardDrugOrderUX-div-165"
                  style={{ display: (props.roleTypes || []).includes("DOCTOR") ? "none" : "", minWidth: "max-content" }}>
                  {props.languageUX === "en" ? "Prescribing physician" : "แพทย์ผู้สั่ง"}
                </div>
              </FormField>
              <FormField
                id="CardDrugOrderUX-FormField-166"
                inline={true}
                style={{ display: props.hideCardDrugVerbalOrder ? "" : "none" }}
                width={(props.roleTypes || []).includes("DOCTOR") ? 0 : 7}>
                <div
                  id="CardDrugOrderUX-div-167"
                  style={{"width": "100%", "height": "100%", display: (props.roleTypes || []).includes("DOCTOR") ? "none" : "" }}>
                  {props.doctorElement}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardDrugOrderUX-FormGroup-141"
              inline={true}>
              <FormField
                id="CardDrugOrderUX-FormField-144"
                inline={true}
                width={1}>
                <div
                  id="CardDrugOrderUX-div-153"
                  style={{"gridRow": "14/17", "gridColumn": "2/3", "width": "100%", "height": "100%"}}>
                  {props.languageUX === "en" ? "Note" : "บันทึก"}
                </div>
              </FormField>
              <FormField
                id="CardDrugOrderUX-FormField-145"
                inline={true}
                width={props.showRecon? 5 : 7}>
                <div
                  id="CardDrugOrderUX-div-154"
                  style={{"width": "100%", "height": "100%"}}>
                  
                  <Input
                    id="txt-notetoPharmacy"
                    onChange={props.onChangeDoctorNote}
                    style={{ width: "100%" }}
                    value={props.doctorNote}>
                  </Input>
                </div>
              </FormField>
              <FormField
                id="CardDrugOrderUX-FormField-185"
                style={{flex:1}}>
              </FormField>
              <FormField
                id="CardDrugOrderUX-FormField-146"
                inline={true}>
                <div
                  id="CardDrugOrderUX-div-156"
                  style={{"width": "100%", "height": "100%", display: "flex",minWidth:"max-content"}}>
                  
                  <Button
                    disabled={props.statusRequest ? false : true}
                    id="btn-remed"
                    onClick={props.onClickREMED}
                    style={{ width: "100%", display: "none" }}>
                    {props.languageUX === "en" ? "REMED" : "ได้รับการแก้ไขแล้ว"}
                  </Button>
                  <Button
                    color="teal"
                    disabled={props.statusRequest ? false : true}
                    id="btn-remed"
                    onClick={props.onClickRecontinueMed}
                    style={{width: "100%", marginRight: "15px", display: props.showRecon? "" : "none"}}>
                    {props.languageUX === "en" ? "RECONTINUE" : "ดำเนินการต่อ"}
                  </Button>
                  <Button
                    color="blue"
                    disabled={props.statusRequest ? false : true}
                    id="CardDrugOrderUX-Button-158"
                    onClick={props.onClickDrugHistory}
                    style={{width: "100%", minWidth: "max-content"}}>
                    {props.languageUX === "en" ? "Drug History" : "ประวัติการใช้ยา"}
                  </Button>
                </div>
              </FormField>
              <FormField
                id="CardDrugOrderUX-FormField-147"
                inline={true}>
                <div
                  id="CardDrugOrderUX-div-159"
                  style={{"width": "100%", "height": "100%"}}>
                  
                  <Button
                    disabled={props.statusRequest ? false : true}
                    id="btn-medSet"
                    onClick={props.onClickOrderset}
                    style={{ width: "100%" , minWidth:"max-content"}}>
                    {props.languageUX === "en" ? "Medical kit" : "ชุดยา"}
                  </Button>
                </div>
              </FormField>
              <FormField
                id="CardDrugOrderUX-FormField-181"
                inline={true}
                style={{ ...(!props.isStudentUser && {display: "none"})}}
                width={2}>
                <div
                  id="CardDrugOrderUX-div-182"
                  style={{"width": "100%", "height": "100%"}}>
                  
                  <div
                    id="CardDrugOrderUX-div-183">
                    {props.buttonSaveOrder}
                  </div>
                </div>
              </FormField>
              <FormField
                id="CardDrugOrderUX-FormField-148"
                inline={true}>
                <div
                  id="CardDrugOrderUX-div-161"
                  style={{"width": "100%", "height": "100%",minWidth:"max-content"}}>
                  
                  <Button
                    color="green"
                    disabled={props.statusRequest ? false : true}
                    id="btn-confirmMedOrder"
                    onClick={props.confirmOrder}
                    style={{ width: "100%", ...(props.disabledConfirmedOrderBtn && {display: "none"})}}>
                    {props.languageUX === "en" ? "CONFIRM ORDER" : "ยืนยันการสั่งซื้อ"}
                  </Button>
                  <div
                    id="CardDrugOrderUX-div-168">
                    {props.buttonConfirmOrder}
                  </div>
                </div>
              </FormField>
            </FormGroup>
          </div>
        </div>
        <div
          id="CardDrugOrderUX-div-237"
          style={{display: props.openCalCulator ? "none" : "none", position:"absolute", width:"70%", height:"180px", right:"16px", top:"10px", backgroundColor:"red"}}>
          {props.pediatricUI}
        </div>
      </div>
    )
}


export default CardDrugOrderUX

export const screenPropsDefault = {"language":"TH","orderType":"ONE_DOSE","selectedDrug":{},"showSearchResult":true}

/* Date Time : Wed Oct 01 2025 12:30:18 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ position: \"relative\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{display:  props.statusRequest ? \"grid\" : \"none\",    gridTemplateColumns: \"repeat(9, minmax(0, 1fr))\", padding: \"5px\",}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"none\"  }"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.statusRequest ? \"\" : \"none\", padding: \"5px\"}"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-40"
        },
        "style": {
          "type": "code",
          "value": "{\"height\": \"110px\", \"display\": \"grid\", \"gridTemplateRows\": \"10.638297872340425% 5.319148936170213% 4.25531914893617% 2.127659574468085% 3.1914893617021276% 3.1914893617021276% 2.127659574468085% 2.127659574468085% 3.1914893617021276% 8.51063829787234% 5.319148936170213% 2.127659574468085% 9.574468085106384% 1.0638297872340425% 1.0638297872340425% 7.446808510638298% 1.0638297872340425% 1.0638297872340425% 2.127659574468085% 6.382978723404255% 2.127659574468085% 15.957446808510639%\", \"gridTemplateColumns\": \"0.5198180636777128% 1.949317738791423% 2.2092267706302793% 2.079272254710851% 0.8447043534762833% 6.562703053931124% 0.3898635477582846% 3.833658219623132% 37.10201429499675% 0.9746588693957114% 3.5737491877842755% 0.8447043534762833% 0.3898635477582846% 3.248862897985705% 3.378817413905133% 0.9746588693957114% 4.028589993502274% 0.9096816114359974% 0.3248862897985705% 2.3391812865497075% 3.898635477582846% 0.9746588693957114% 5.003248862897986% 4.158544509421702% 0.3248862897985705% 3.248862897985705% 3.898635477582846% 0.4548408057179987% 0.5847953216374269% 0.9746588693957114%\"}"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "div",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-41"
        },
        "style": {
          "type": "code",
          "value": "{\"gridRow\": \"2/11\", \"gridColumn\": \"5/30\",  \"width\": \"100%\", \"height\": \"100%\"}"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "div",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": "x",
          "valueEN": "x"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-44"
        },
        "style": {
          "type": "code",
          "value": "{\"gridRow\": \"6/7\", \"gridColumn\": \"28/29\", \"border\": \"solid black 1px\", \"width\": \"100%\", \"height\": \"100%\"}"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "div",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนกที่สั่ง",
          "valueEN": "Ordering department"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-45"
        },
        "style": {
          "type": "code",
          "value": "{\"gridRow\": \"3/8\", \"gridColumn\": \"2/4\", \"width\": \"100%\", \"height\": \"100%\"}"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "div",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-46"
        },
        "style": {
          "type": "code",
          "value": "{\"gridRow\": \"12/22\", \"gridColumn\": \"5/10\", \"width\": \"100%\", \"height\": \"100%\"}"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "div",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-47"
        },
        "style": {
          "type": "code",
          "value": "{\"gridRow\": \"13/21\", \"gridColumn\": \"11/16\", \"width\": \"100%\", \"height\": \"100%\"}"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "div",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึก",
          "valueEN": "Note"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-50"
        },
        "style": {
          "type": "code",
          "value": "{\"gridRow\": \"14/17\", \"gridColumn\": \"2/3\", \"width\": \"100%\", \"height\": \"100%\"}"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "div",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-51"
        },
        "style": {
          "type": "code",
          "value": "{\"gridRow\": \"13/21\", \"gridColumn\": \"17/22\", \"width\": \"100%\", \"height\": \"100%\"}"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "div",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-54"
        },
        "style": {
          "type": "code",
          "value": "{\"gridRow\": \"13/21\", \"gridColumn\": \"23/30\", \"width\": \"100%\", \"height\": \"100%\"}"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "Dropdown",
      "parent": 41,
      "props": {
        "compact": {
          "type": "code",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-Dropdown-55"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDivision"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" , height: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.orderDiv"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 56,
      "name": "Button",
      "parent": 47,
      "props": {
        "children": {
          "type": "value",
          "value": "ได้รับการแก้ไขแล้ว",
          "valueEN": "REMED"
        },
        "color": {
          "type": "value",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "props.statusRequest ? false : true"
        },
        "id": {
          "type": "value",
          "value": "btn-remed"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickREMED"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", display: \"none\" }"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "Button",
      "parent": 51,
      "props": {
        "children": {
          "type": "value",
          "value": "ชุดยา",
          "valueEN": "Medical kit"
        },
        "disabled": {
          "type": "code",
          "value": "props.statusRequest ? false : true"
        },
        "id": {
          "type": "value",
          "value": "btn-medSet"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickOrderset"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "Input",
      "parent": 46,
      "props": {
        "id": {
          "type": "value",
          "value": "txt-notetoPharmacy"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDoctorNote"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        },
        "type": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.doctorNote"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "Button",
      "parent": 54,
      "props": {
        "children": {
          "type": "value",
          "value": "ยืนยันการสั่งซื้อ",
          "valueEN": "CONFIRM ORDER"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "props.statusRequest ? false : true"
        },
        "id": {
          "type": "value",
          "value": "btn-confirmMedOrder"
        },
        "onClick": {
          "type": "code",
          "value": "props.confirmOrder"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", ...(props.disabledConfirmedOrderBtn && {display: \"none\"})}"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 63,
      "name": "Table",
      "parent": 4,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "columns": {
          "type": "value",
          "value": ""
        },
        "data": {
          "type": "code",
          "value": "props.drugOrderItems"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.drugItemsTrProps"
        },
        "headers": {
          "type": "value",
          "value": "Drug,Dose,Unit,Route,Site,Frequency,PRN,QTY,Duration,Price/Unit,Total Price,"
        },
        "id": {
          "type": "value",
          "value": "tb-medicationList"
        },
        "keys": {
          "type": "value",
          "value": "title_status,dose,unit,route,site,frequency,prn,quantity,duration,price_unit,price_total,_remove"
        },
        "minRows": {
          "type": "value",
          "value": "8"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{  height: \"325px\",display: \"none\" }"
        },
        "widths": {
          "type": "value",
          "value": "^110,^60,^90,^90,^90,^115,^60,^60,^70,^80,^75,^50"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": null,
      "id": 70,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-70"
        },
        "style": {
          "type": "code",
          "value": "{ position: \"relative\", padding: \"5px\", ...( props.hiddenDrugList ? {display: \"none\"} : {display: \"block\"}) }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 71,
      "name": "Table",
      "parent": 70,
      "props": {
        "NoDataComponent": {
          "type": "code",
          "value": "props.noDataComponent"
        },
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.drugOrderList"
        },
        "getTdProps": {
          "type": "code",
          "value": "props.listRowProps"
        },
        "getTrProps": {
          "type": "code",
          "value": ""
        },
        "headers": {
          "type": "value",
          "value": "Code, Created,Status,Summary,Careprovider,Del, Edit"
        },
        "id": {
          "type": "value",
          "value": "tb-medOrderList"
        },
        "keys": {
          "type": "value",
          "value": "code,created,status,summary,careprovider,delete,edit"
        },
        "minRows": {
          "type": "code",
          "value": "props.minRows ? props.minRows : 6"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "props.styleDrugOrderTable"
        },
        "widths": {
          "type": "value",
          "value": "^90,^110,115,^310,^150,^75,^75"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": null,
      "id": 72,
      "name": "div",
      "parent": 73,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการใบยา",
          "valueEN": "Prescription Detail"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-72"
        },
        "style": {
          "type": "code",
          "value": "{ fontSize: \"1.2rem\", fontWeight: \"bold\", marginBottom: \"0rem\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 73,
      "name": "div",
      "parent": 70,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-73"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": null,
      "id": 74,
      "name": "div",
      "parent": 73,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-74"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 175,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 75,
      "name": "Button",
      "parent": 73,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่มใบยา",
          "valueEN": "Add a new prescription"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledAddDrugOrderBtn"
        },
        "id": {
          "type": "value",
          "value": "btn-addMedOrder"
        },
        "onClick": {
          "type": "code",
          "value": "props.addNewOrder"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 251,
      "void": false
    },
    {
      "from": null,
      "id": 76,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ErrorMessage"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-76"
        },
        "style": {
          "type": "code",
          "value": "{ gridColumn: \"1/10\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 90,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-90"
        },
        "style": {
          "type": "code",
          "value": "{ gridColumn: \"1/10\", fontWeight: \"bold\" ,display:\"flex\" , fontSize: \"1.2rem\", margin: \"20px 0px\"}"
        }
      },
      "seq": 169,
      "void": false
    },
    {
      "from": null,
      "id": 91,
      "name": "div",
      "parent": 90,
      "props": {
        "children": {
          "type": "code",
          "value": "props?.orderStatus"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-91"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px \" }"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "div",
      "parent": 90,
      "props": {
        "children": {
          "type": "code",
          "value": "props?.orderName"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-92"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": null,
      "id": 93,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-93"
        },
        "style": {
          "type": "code",
          "value": "{gridColumn: \"1/10\", paddingLeft: \"1rem\", marginTop: \"-0.25rem\", display: \"none\"}"
        }
      },
      "seq": 237,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 94,
      "name": "FormGroup",
      "parent": 93,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormGroup-94"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 95,
      "name": "FormField",
      "parent": 94,
      "props": {
        "className": {
          "type": "code",
          "value": "`required noPadding${props.errorMessage &&!props.drugDose  ? \" error\" :\"\"}${props.hideDrugForm?.dose ? \" hidden\": \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-95"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft:0}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": null,
      "id": 96,
      "name": "label",
      "parent": 95,
      "props": {
        "children": {
          "type": "value",
          "value": "ปริมาณยา",
          "valueEN": "Dose"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-label-96"
        },
        "style": {
          "type": "code",
          "value": "{margin:0}"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 98,
      "name": "FormField",
      "parent": 94,
      "props": {
        "className": {
          "type": "code",
          "value": "`required noPadding${props.errorMessage &&!props.selectedDrugUnitId ? \" error\" :\"\"}${props.hideDrugForm?.unit ? \" hidden\": \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-98"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft:0}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 99,
      "name": "FormField",
      "parent": 94,
      "props": {
        "className": {
          "type": "code",
          "value": "`required noPadding${props.errorMessage &&!props.selectedDrugRouteId ? \" error\" :\"\"}${props.hideDrugForm?.route ? \" hidden\": \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-99"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft:0}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 100,
      "name": "FormField",
      "parent": 94,
      "props": {
        "className": {
          "type": "code",
          "value": "`required noPadding${props.errorMessage &&!props.selectedDrugSiteId? \" error\" :\"\" }${props.hideDrugForm?.site ? \" hidden\": \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-100"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft:0}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 101,
      "name": "FormField",
      "parent": 94,
      "props": {
        "className": {
          "type": "code",
          "value": "`required noPadding${props.errorMessage &&!props.selectedDrugFrequencyId? \" error\" :\"\" }${props.hideDrugForm?.frequency ? \" hidden\": \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-101"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft:0}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 102,
      "name": "FormField",
      "parent": 94,
      "props": {
        "className": {
          "type": "code",
          "value": "`required noPadding${props.hideDrugForm?.method ? \" hidden\": \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-102"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft:0}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 103,
      "name": "FormField",
      "parent": 94,
      "props": {
        "className": {
          "type": "code",
          "value": "`required noPadding${props.errorMessage &&!props.drugQty? \" error\" :\"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-103"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft:0}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 104,
      "name": "FormField",
      "parent": 94,
      "props": {
        "className": {
          "type": "code",
          "value": "`${props.noRequiredDuration ? \"\":\"required \"}noPadding${props.hideDrugForm?.duration ? \" hidden\": \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-104"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft:0}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 105,
      "name": "FormField",
      "parent": 94,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-105"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": null,
      "id": 106,
      "name": "label",
      "parent": 98,
      "props": {
        "children": {
          "type": "value",
          "value": "หน่วย",
          "valueEN": "Unit"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-label-106"
        },
        "style": {
          "type": "code",
          "value": "{margin:0}"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": null,
      "id": 107,
      "name": "label",
      "parent": 99,
      "props": {
        "children": {
          "type": "value",
          "value": "ช่องทาง",
          "valueEN": "Route"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-label-107"
        },
        "style": {
          "type": "code",
          "value": "{margin:0}"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": null,
      "id": 108,
      "name": "label",
      "parent": 100,
      "props": {
        "children": {
          "type": "value",
          "value": "ตำแหน่ง",
          "valueEN": "Site"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-label-108"
        },
        "style": {
          "type": "code",
          "value": "{margin:0}"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": null,
      "id": 109,
      "name": "label",
      "parent": 101,
      "props": {
        "children": {
          "type": "value",
          "value": "ความถี่",
          "valueEN": "Frequency"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-label-109"
        },
        "style": {
          "type": "code",
          "value": "{margin:0}"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": null,
      "id": 110,
      "name": "label",
      "parent": 102,
      "props": {
        "children": {
          "type": "value",
          "value": "วิธี",
          "valueEN": "Method"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-label-110"
        },
        "style": {
          "type": "code",
          "value": "{margin:0}"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": null,
      "id": 111,
      "name": "label",
      "parent": 103,
      "props": {
        "children": {
          "type": "value",
          "value": "จำนวน",
          "valueEN": "Qty"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-label-111"
        },
        "style": {
          "type": "code",
          "value": "{margin:0}"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": null,
      "id": 112,
      "name": "label",
      "parent": 104,
      "props": {
        "children": {
          "type": "value",
          "value": "ระยะเวลา (วัน)",
          "valueEN": "Duration (day)"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-label-112"
        },
        "style": {
          "type": "code",
          "value": "{margin:0}"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 113,
      "name": "Dropdown",
      "parent": 98,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedDrug"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "cb-drugUnit"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeDrugUnit"
        },
        "options": {
          "type": "code",
          "value": "props.drugUnits"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.selectedDrugUnitId"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 114,
      "name": "Dropdown",
      "parent": 99,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedDrug"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "cb-drugRoute"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeDrugRoute"
        },
        "options": {
          "type": "code",
          "value": "props.drugRoutes"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.selectedDrugRouteId"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 115,
      "name": "Dropdown",
      "parent": 100,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedDrug"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "cb-drugSite"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeDrugSite"
        },
        "options": {
          "type": "code",
          "value": "props.drugSites"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.selectedDrugSiteId"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 116,
      "name": "Dropdown",
      "parent": 101,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedDrug"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "cb-drugFrequency"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeDrugFrequency"
        },
        "options": {
          "type": "code",
          "value": "props.drugFrequencies"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.selectedDrugFrequencyId"
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 117,
      "name": "Dropdown",
      "parent": 102,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedDrug"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "cb-drugMedthod"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeDrugMethod"
        },
        "options": {
          "type": "code",
          "value": "props.drugMethods"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.selectedDrugMethodId"
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 118,
      "name": "Input",
      "parent": 103,
      "props": {
        "className": {
          "type": "code",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedDrug"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "txt-drugQty"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeDrugQty"
        },
        "style": {
          "type": "code",
          "value": "{opacity: 1}"
        },
        "value": {
          "type": "code",
          "value": "props.drugQty ? props.drugQty : \"\""
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 119,
      "name": "Input",
      "parent": 104,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.selectedDrug"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "txt-drugDuration"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeDrugDuration"
        },
        "readOnly": {
          "type": "code",
          "value": "props.readOnlyDuration || false"
        },
        "style": {
          "type": "code",
          "value": "{opacity: 1}"
        },
        "value": {
          "type": "code",
          "value": "props.drugDuration ? props.drugDuration: \"\""
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 120,
      "name": "Button",
      "parent": 105,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่มลงในคำสั่งซื้อ",
          "valueEN": "ADD TO ORDER"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "props.statusRequest ? false : true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "btn-addMedOrder"
        },
        "onClick": {
          "type": "code",
          "value": "props.addToOrder"
        },
        "size": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"20.5px\", width: \"150px\"}"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": null,
      "id": 121,
      "name": "div",
      "parent": 94,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "field  noPadding"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-121"
        },
        "style": {
          "type": "code",
          "value": "{flex: props.drugFormFlexStyle ? 1 : \"\"}"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 122,
      "name": "Button",
      "parent": 47,
      "props": {
        "children": {
          "type": "value",
          "value": "ประวัติการใช้ยา",
          "valueEN": "Drug History"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "props.statusRequest ? false : true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-Button-122"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickDrugHistory"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": null,
      "id": 123,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-123"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.statusRequest ? \"\" : \"none\"  }"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": null,
      "id": 139,
      "name": "div",
      "parent": 123,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\"}"
        }
      },
      "seq": 255,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 140,
      "name": "FormGroup",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormGroup-140"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 140,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 141,
      "name": "FormGroup",
      "parent": 139,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormGroup-141"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 142,
      "name": "FormField",
      "parent": 140,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-142"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "value",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 143,
      "name": "FormField",
      "parent": 140,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-143"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "value",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "(props.roleTypes || []).includes(\"DOCTOR\") ? 15 : 7"
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 144,
      "name": "FormField",
      "parent": 141,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-144"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 145,
      "name": "FormField",
      "parent": 141,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-145"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "props.showRecon? 5 : 7"
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 146,
      "name": "FormField",
      "parent": 141,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-146"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 147,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 147,
      "name": "FormField",
      "parent": 141,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-147"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 148,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 148,
      "name": "FormField",
      "parent": 141,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-148"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 185,
      "void": false
    },
    {
      "from": null,
      "id": 150,
      "name": "div",
      "parent": 143,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-150"
        },
        "style": {
          "type": "code",
          "value": "{\"width\": \"100%\", \"height\": \"100%\"}"
        }
      },
      "seq": 150,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 151,
      "name": "Dropdown",
      "parent": 150,
      "props": {
        "compact": {
          "type": "code",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-Dropdown-151"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDivision"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" , height: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.orderDiv"
        }
      },
      "seq": 151,
      "void": false
    },
    {
      "from": null,
      "id": 152,
      "name": "div",
      "parent": 142,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนกที่สั่ง",
          "valueEN": "Ordering department"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-152"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": null,
      "id": 153,
      "name": "div",
      "parent": 144,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึก",
          "valueEN": "Note"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-153"
        },
        "style": {
          "type": "code",
          "value": "{\"gridRow\": \"14/17\", \"gridColumn\": \"2/3\", \"width\": \"100%\", \"height\": \"100%\"}"
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": null,
      "id": 154,
      "name": "div",
      "parent": 145,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-154"
        },
        "style": {
          "type": "code",
          "value": "{\"width\": \"100%\", \"height\": \"100%\"}"
        }
      },
      "seq": 154,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 155,
      "name": "Input",
      "parent": 154,
      "props": {
        "id": {
          "type": "value",
          "value": "txt-notetoPharmacy"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDoctorNote"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        },
        "type": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.doctorNote"
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": null,
      "id": 156,
      "name": "div",
      "parent": 146,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-156"
        },
        "style": {
          "type": "code",
          "value": "{\"width\": \"100%\", \"height\": \"100%\", display: \"flex\",minWidth:\"max-content\"}"
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 157,
      "name": "Button",
      "parent": 156,
      "props": {
        "children": {
          "type": "value",
          "value": "ได้รับการแก้ไขแล้ว",
          "valueEN": "REMED"
        },
        "color": {
          "type": "value",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "props.statusRequest ? false : true"
        },
        "id": {
          "type": "value",
          "value": "btn-remed"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickREMED"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", display: \"none\" }"
        }
      },
      "seq": 157,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 158,
      "name": "Button",
      "parent": 156,
      "props": {
        "children": {
          "type": "value",
          "value": "ประวัติการใช้ยา",
          "valueEN": "Drug History"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "props.statusRequest ? false : true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-Button-158"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickDrugHistory"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", minWidth: \"max-content\"}"
        }
      },
      "seq": 163,
      "void": false
    },
    {
      "from": null,
      "id": 159,
      "name": "div",
      "parent": 147,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-159"
        },
        "style": {
          "type": "code",
          "value": "{\"width\": \"100%\", \"height\": \"100%\"}"
        }
      },
      "seq": 159,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 160,
      "name": "Button",
      "parent": 159,
      "props": {
        "children": {
          "type": "value",
          "value": "ชุดยา",
          "valueEN": "Medical kit"
        },
        "disabled": {
          "type": "code",
          "value": "props.statusRequest ? false : true"
        },
        "id": {
          "type": "value",
          "value": "btn-medSet"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickOrderset"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" , minWidth:\"max-content\"}"
        }
      },
      "seq": 160,
      "void": false
    },
    {
      "from": null,
      "id": 161,
      "name": "div",
      "parent": 148,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-161"
        },
        "style": {
          "type": "code",
          "value": "{\"width\": \"100%\", \"height\": \"100%\",minWidth:\"max-content\"}"
        }
      },
      "seq": 161,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 162,
      "name": "Button",
      "parent": 161,
      "props": {
        "children": {
          "type": "value",
          "value": "ยืนยันการสั่งซื้อ",
          "valueEN": "CONFIRM ORDER"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "props.statusRequest ? false : true"
        },
        "id": {
          "type": "value",
          "value": "btn-confirmMedOrder"
        },
        "onClick": {
          "type": "code",
          "value": "props.confirmOrder"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", ...(props.disabledConfirmedOrderBtn && {display: \"none\"})}"
        }
      },
      "seq": 162,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 163,
      "name": "Button",
      "parent": 156,
      "props": {
        "children": {
          "type": "value",
          "value": "ดำเนินการต่อ",
          "valueEN": "RECONTINUE"
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "disabled": {
          "type": "code",
          "value": "props.statusRequest ? false : true"
        },
        "id": {
          "type": "value",
          "value": "btn-remed"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickRecontinueMed"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", marginRight: \"15px\", display: props.showRecon? \"\" : \"none\"}"
        }
      },
      "seq": 158,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 164,
      "name": "FormField",
      "parent": 140,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-164"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.hideCardDrugVerbalOrder ? \"\" : \"none\" }"
        },
        "width": {
          "type": "code",
          "value": "(props.roleTypes || []).includes(\"DOCTOR\") ? 0 : 1"
        }
      },
      "seq": 164,
      "void": false
    },
    {
      "from": null,
      "id": 165,
      "name": "div",
      "parent": 164,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์ผู้สั่ง",
          "valueEN": "Prescribing physician"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-165"
        },
        "style": {
          "type": "code",
          "value": "{ display: (props.roleTypes || []).includes(\"DOCTOR\") ? \"none\" : \"\", minWidth: \"max-content\" }"
        }
      },
      "seq": 165,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 166,
      "name": "FormField",
      "parent": 140,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-166"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.hideCardDrugVerbalOrder ? \"\" : \"none\" }"
        },
        "width": {
          "type": "code",
          "value": "(props.roleTypes || []).includes(\"DOCTOR\") ? 0 : 7"
        }
      },
      "seq": 166,
      "void": false
    },
    {
      "from": null,
      "id": 167,
      "name": "div",
      "parent": 166,
      "props": {
        "children": {
          "type": "code",
          "value": "props.doctorElement"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-167"
        },
        "style": {
          "type": "code",
          "value": "{\"width\": \"100%\", \"height\": \"100%\", display: (props.roleTypes || []).includes(\"DOCTOR\") ? \"none\" : \"\" }"
        }
      },
      "seq": 167,
      "void": false
    },
    {
      "from": null,
      "id": 168,
      "name": "div",
      "parent": 161,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonConfirmOrder"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-168"
        }
      },
      "seq": 168,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 171,
      "name": "Button",
      "parent": 73,
      "props": {
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledPrintDrugOrderBtn"
        },
        "icon": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-Button-171"
        },
        "labelPosition": {
          "type": "value",
          "value": "left"
        },
        "onClick": {
          "type": "code",
          "value": "props.onPrintDrugOrder"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 248,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 172,
      "name": "Icon",
      "parent": 171,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-Icon-172"
        },
        "name": {
          "type": "value",
          "value": "print"
        }
      },
      "seq": 172,
      "void": false
    },
    {
      "from": null,
      "id": 174,
      "name": "label",
      "parent": 171,
      "props": {
        "children": {
          "type": "value",
          "value": "พิมพ์ใบสั่งยา",
          "valueEN": "Print prescription"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-label-174"
        }
      },
      "seq": 174,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 175,
      "name": "Button",
      "parent": 73,
      "props": {
        "children": {
          "type": "value",
          "value": "พิมพ์ใบ ยส.",
          "valueEN": "Print the form."
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-Button-175"
        },
        "loading": {
          "type": "code",
          "value": "props.loadingStatus?.PRINT_NARCOTIC_FORM"
        },
        "onClick": {
          "type": "code",
          "value": "props.onPrintNarcotic"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{display: props.isShowNarcoticPrint ? \"\" : \"none\"}"
        }
      },
      "seq": 176,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 176,
      "name": "Button",
      "parent": 73,
      "props": {
        "children": {
          "type": "value",
          "value": "พิมพ์สั่งจ่ายวัตถุออกฤทธิ์",
          "valueEN": "Print the order to dispense the active substance"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-Button-176"
        },
        "loading": {
          "type": "code",
          "value": "props.loadingStatus?.PRINT_PSYCHOTROPIC_FORM"
        },
        "onClick": {
          "type": "code",
          "value": "props.onPrintPsychotropic"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{display: props.isShowPsychotropicPrint? \"\" : \"none\"}"
        }
      },
      "seq": 239,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 177,
      "name": "FormGroup",
      "parent": 93,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormGroup-177"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.hideDrugDescription ? \"none\" : \"\"}"
        }
      },
      "seq": 177,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 178,
      "name": "FormField",
      "parent": 177,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-178"
        },
        "style": {
          "type": "code",
          "value": "{padding: 0, marginTop: \"-0.5rem\"}"
        },
        "width": {
          "type": "code",
          "value": "Object.values({...(props.hideDrugForm || {}),qty:false}).reduce((r,v)=>r+=(!!v ? 0 : 2),0)"
        }
      },
      "seq": 178,
      "void": false
    },
    {
      "from": null,
      "id": 179,
      "name": "label",
      "parent": 178,
      "props": {
        "children": {
          "type": "value",
          "value": "คำอธิบาย",
          "valueEN": "Description"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-label-179"
        },
        "style": {
          "type": "code",
          "value": "{margin:0}"
        }
      },
      "seq": 179,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 180,
      "name": "Input",
      "parent": 178,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.selectedDrug"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "txt-drugDescription"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeDrugDescription"
        },
        "style": {
          "type": "code",
          "value": "{opacity: 1}"
        },
        "value": {
          "type": "code",
          "value": "props.drugDescription || \"\""
        }
      },
      "seq": 180,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 181,
      "name": "FormField",
      "parent": 141,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-181"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ ...(!props.isStudentUser && {display: \"none\"})}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 181,
      "void": false
    },
    {
      "from": null,
      "id": 182,
      "name": "div",
      "parent": 181,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-182"
        },
        "style": {
          "type": "code",
          "value": "{\"width\": \"100%\", \"height\": \"100%\"}"
        }
      },
      "seq": 182,
      "void": false
    },
    {
      "from": null,
      "id": 183,
      "name": "div",
      "parent": 182,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSaveOrder"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-183"
        }
      },
      "seq": 183,
      "void": false
    },
    {
      "from": null,
      "id": 184,
      "name": "div",
      "parent": 90,
      "props": {
        "children": {
          "type": "code",
          "value": "props?.approveStatus"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-184"
        },
        "style": {
          "type": "code",
          "value": "{ fontSize: \"14px\" }"
        }
      },
      "seq": 184,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 185,
      "name": "FormField",
      "parent": 141,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-185"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 146,
      "void": false
    },
    {
      "from": null,
      "id": 187,
      "name": "div",
      "parent": 90,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-187"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 187,
      "void": false
    },
    {
      "from": null,
      "id": 188,
      "name": "div",
      "parent": 90,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form --override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-188"
        },
        "style": {
          "type": "code",
          "value": "{display:  props.showTelepharType?\"flex\":\"none\"}"
        }
      },
      "seq": 188,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 189,
      "name": "Checkbox",
      "parent": 188,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.telepharType=== \"DELIVERY\""
        },
        "className": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "props.hasDrugTransportNotAllowed"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-Checkbox-189"
        },
        "label": {
          "type": "value",
          "value": "บริการส่งถึงบ้าน",
          "valueEN": "Home delivery"
        },
        "name": {
          "type": "value",
          "value": "DELIVERY"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeTelepharType"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 189,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 190,
      "name": "Checkbox",
      "parent": 188,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.telepharType=== \"INTRA\""
        },
        "className": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-Checkbox-190"
        },
        "label": {
          "type": "value",
          "value": "เภสัชกรรมทางไกลภายในโรงพยาบาล",
          "valueEN": "Intrahospital Telepharmacy"
        },
        "name": {
          "type": "value",
          "value": "INTRA"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeTelepharType"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", margin: \"0 1rem\"}"
        }
      },
      "seq": 190,
      "void": false
    },
    {
      "from": null,
      "id": 192,
      "name": "div",
      "parent": 70,
      "props": {
        "children": {
          "type": "code",
          "value": "props.loader"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-192"
        }
      },
      "seq": 192,
      "void": false
    },
    {
      "from": null,
      "id": 193,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-193"
        },
        "style": {
          "type": "code",
          "value": "{gridColumn: \"1/10\", paddingLeft: \"1rem\", marginTop: \"-0.5rem\", display: \"none\"}"
        }
      },
      "seq": 193,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 194,
      "name": "FormGroup",
      "parent": 193,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormGroup-194"
        },
        "widths": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 194,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 195,
      "name": "FormField",
      "parent": 194,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-195"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft:0}"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 195,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 196,
      "name": "FormField",
      "parent": 194,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-196"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft:0}"
        }
      },
      "seq": 196,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 197,
      "name": "FormField",
      "parent": 194,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-197"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft:0}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 204,
      "void": false
    },
    {
      "from": null,
      "id": 199,
      "name": "div",
      "parent": 195,
      "props": {
        "children": {
          "type": "code",
          "value": "props.DrugSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-199"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 225,
      "void": false
    },
    {
      "from": null,
      "id": 200,
      "name": "label",
      "parent": 196,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-label-200"
        },
        "style": {
          "type": "code",
          "value": "{margin:0}"
        }
      },
      "seq": 200,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 201,
      "name": "Button",
      "parent": 196,
      "props": {
        "children": {
          "type": "value",
          "value": "ข้อเท็จจริงเกี่ยวกับยาเสพติด",
          "valueEN": "DRUG FACT"
        },
        "color": {
          "type": "code",
          "value": "props.hasFactSheet ? \"blue\" : undefined"
        },
        "disabled": {
          "type": "code",
          "value": "!props.hasFactSheet"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-Button-201"
        },
        "onClick": {
          "type": "code",
          "value": "props.openFactSheet"
        },
        "style": {
          "type": "code",
          "value": "{ whiteSpace: \"nowrap\"}"
        }
      },
      "seq": 201,
      "void": false
    },
    {
      "from": null,
      "id": 202,
      "name": "label",
      "parent": 197,
      "props": {
        "children": {
          "type": "value",
          "value": "PRN",
          "valueEN": "PRN"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-label-202"
        },
        "style": {
          "type": "code",
          "value": "{margin:0}"
        }
      },
      "seq": 202,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 203,
      "name": "Input",
      "parent": 197,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.selectedDrug "
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-Input-203"
        },
        "onChange": {
          "type": "code",
          "value": "props.ChangeDrugPrn"
        },
        "value": {
          "type": "code",
          "value": "props.drugPrn? props.drugPrn : \"\""
        }
      },
      "seq": 203,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 204,
      "name": "FormField",
      "parent": 194,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-204"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.drugPermission?.config_TPD_ENABLE_IV_COMPATIBLE ? \"\" : \"none\",paddingLeft:0}"
        }
      },
      "seq": 214,
      "void": false
    },
    {
      "from": null,
      "id": 206,
      "name": "label",
      "parent": 204,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-label-206"
        },
        "style": {
          "type": "code",
          "value": "{margin:0}"
        }
      },
      "seq": 205,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 214,
      "name": "FormField",
      "parent": 194,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-214"
        },
        "style": {
          "type": "code",
          "value": "{display: props.selectedDrug?.original?.is_taper_dose ? \"\": \"none\",  fontWeight: \"bold\",paddingLeft:0 }"
        }
      },
      "seq": 215,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 215,
      "name": "FormField",
      "parent": 194,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-215"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 216,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 216,
      "name": "FormField",
      "parent": 194,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-216"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft:0}"
        }
      },
      "seq": 227,
      "void": false
    },
    {
      "from": null,
      "id": 217,
      "name": "label",
      "parent": 214,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-label-217"
        },
        "style": {
          "type": "code",
          "value": "{margin:0}"
        }
      },
      "seq": 217,
      "void": false
    },
    {
      "from": null,
      "id": 218,
      "name": "label",
      "parent": 216,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-label-218"
        },
        "style": {
          "type": "code",
          "value": "{margin:0}"
        }
      },
      "seq": 218,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 219,
      "name": "Button",
      "parent": 216,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.statusRequest ? false : true"
        },
        "icon": {
          "type": "value",
          "value": "file"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-Button-219"
        },
        "onClick": {
          "type": "code",
          "value": "props.clearDrugOrderForm"
        }
      },
      "seq": 219,
      "void": false
    },
    {
      "from": null,
      "id": 221,
      "name": "div",
      "parent": 214,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonTaperSchedule"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-221"
        }
      },
      "seq": 221,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 222,
      "name": "FormField",
      "parent": 194,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-222"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.drugPermission?.config_TPD_ENABLE_PTC_DISPENSE  ? \"\" : \"none\",paddingLeft:0}"
        }
      },
      "seq": 222,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 223,
      "name": "Button",
      "parent": 222,
      "props": {
        "children": {
          "type": "value",
          "value": "ยาแบ่งจ่าย",
          "valueEN": "Drug distribution"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "!props.enabledButtonDispense"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-Button-223"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickDispense"
        }
      },
      "seq": 224,
      "void": false
    },
    {
      "from": null,
      "id": 224,
      "name": "label",
      "parent": 222,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-label-224"
        },
        "style": {
          "type": "code",
          "value": "{margin:0}"
        }
      },
      "seq": 223,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 225,
      "name": "FormField",
      "parent": 195,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-225"
        }
      },
      "seq": 199,
      "void": false
    },
    {
      "from": null,
      "id": 226,
      "name": "label",
      "parent": 225,
      "props": {
        "children": {
          "type": "value",
          "value": "ยา",
          "valueEN": "Drug"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-label-226"
        },
        "style": {
          "type": "code",
          "value": "{margin:0}"
        }
      },
      "seq": 226,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 227,
      "name": "FormField",
      "parent": 194,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-227"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft:0}"
        }
      },
      "seq": 197,
      "void": false
    },
    {
      "from": null,
      "id": 228,
      "name": "label",
      "parent": 227,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00a0\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-label-228"
        },
        "style": {
          "type": "code",
          "value": "{margin:0}"
        }
      },
      "seq": 228,
      "void": false
    },
    {
      "from": null,
      "id": 231,
      "name": "div",
      "parent": 227,
      "props": {
        "children": {
          "type": "code",
          "value": "props.calculatorIcon"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-231"
        }
      },
      "seq": 231,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 232,
      "name": "Button",
      "parent": 204,
      "props": {
        "children": {
          "type": "value",
          "value": "ตัวทำละลาย",
          "valueEN": "solvent"
        },
        "disabled": {
          "type": "code",
          "value": "!props.modSolventSelectionConfig?.showButtonSolvent "
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-Button-232"
        },
        "name": {
          "type": "value",
          "value": ""
        },
        "onClick": {
          "type": "code",
          "value": "props.onOpenModSolventSelection"
        }
      },
      "seq": 232,
      "void": false
    },
    {
      "from": null,
      "id": 236,
      "name": "div",
      "parent": 93,
      "props": {
        "children": {
          "type": "code",
          "value": "props.pediatricWarning"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-236"
        }
      },
      "seq": 236,
      "void": false
    },
    {
      "from": null,
      "id": 237,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.pediatricUI"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-237"
        },
        "style": {
          "type": "code",
          "value": "{display: props.openCalCulator ? \"none\" : \"none\", position:\"absolute\", width:\"70%\", height:\"180px\", right:\"16px\", top:\"10px\", backgroundColor:\"red\"}"
        }
      },
      "seq": 254,
      "void": false
    },
    {
      "from": null,
      "id": 238,
      "name": "div",
      "parent": 95,
      "props": {
        "children": {
          "type": "code",
          "value": "props.doseInput"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-238"
        }
      },
      "seq": 238,
      "void": false
    },
    {
      "from": null,
      "id": 239,
      "name": "div",
      "parent": 73,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form size mini"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-239"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"baseline\", fontSize: \"\"}"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 241,
      "name": "DateTextBox",
      "parent": 239,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-DateTextBox-241"
        },
        "onChange": {
          "type": "code",
          "value": "(date)=>props.onChangeFilterCreateDate?.({date})"
        },
        "value": {
          "type": "code",
          "value": "props.filterCreateDate"
        }
      },
      "seq": 243,
      "void": false
    },
    {
      "from": null,
      "id": 244,
      "name": "div",
      "parent": 239,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-244"
        },
        "style": {
          "type": "code",
          "value": "{cursor: \"pointer\"}"
        }
      },
      "seq": 242,
      "void": false
    },
    {
      "from": null,
      "id": 245,
      "name": "div",
      "parent": 239,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-245"
        },
        "style": {
          "type": "code",
          "value": "{cursor: \"pointer\", marginLeft: \"0.25em\"}"
        }
      },
      "seq": 244,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 246,
      "name": "Icon",
      "parent": 249,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-Icon-246"
        },
        "name": {
          "type": "value",
          "value": "angle double left"
        },
        "onClick": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 246,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 247,
      "name": "Icon",
      "parent": 250,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-Icon-247"
        },
        "name": {
          "type": "value",
          "value": "angle double right"
        },
        "onClick": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 247,
      "void": false
    },
    {
      "from": null,
      "id": 248,
      "name": "label",
      "parent": 73,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่",
          "valueEN": "Date"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-label-248"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.2rem\", margin:\"0rem 1rem 0.025rem 2rem\"}"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 249,
      "name": "Button",
      "parent": 244,
      "props": {
        "circular": {
          "type": "code",
          "value": "true"
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "icon": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-Button-249"
        },
        "onClick": {
          "type": "code",
          "value": "()=>props.onChangeFilterCreateDate?.({type: \"prev\"})"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 249,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 250,
      "name": "Button",
      "parent": 245,
      "props": {
        "circular": {
          "type": "code",
          "value": "true"
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "icon": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-Button-250"
        },
        "onClick": {
          "type": "code",
          "value": "()=>props.onChangeFilterCreateDate?.({type: \"next\"})"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 250,
      "void": false
    },
    {
      "from": null,
      "id": 251,
      "name": "div",
      "parent": 73,
      "props": {
        "children": {
          "type": "code",
          "value": "props.helperLabel"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-251"
        }
      },
      "seq": 171,
      "void": false
    },
    {
      "from": null,
      "id": 252,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "code",
          "value": "props.cardEditMedOrder"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-252"
        },
        "style": {
          "type": "code",
          "value": "{gridColumn: \"1/10\", marginTop: \"-1rem\"}"
        }
      },
      "seq": 252,
      "void": false
    },
    {
      "from": null,
      "id": 253,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "code",
          "value": "props.tableElement"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-253"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 253,
      "void": false
    },
    {
      "from": null,
      "id": 254,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.componentDrugVerbalOrder"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-254"
        },
        "style": {
          "type": "code",
          "value": "{ display: !props.hideCardDrugVerbalOrder && props.statusRequest ? \"\" : \"none\" }"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": null,
      "id": 255,
      "name": "div",
      "parent": 123,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-255"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\"}"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 256,
      "name": "Form",
      "parent": 255,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-Form-256"
        }
      },
      "seq": 256,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 257,
      "name": "FormGroup",
      "parent": 256,
      "props": {
        "className": {
          "type": "value",
          "value": "--override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormGroup-257"
        }
      },
      "seq": 257,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 258,
      "name": "FormField",
      "parent": 257,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-258"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", justifyContent: \"center\" }"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 259,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 259,
      "name": "FormField",
      "parent": 257,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-259"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 260,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 260,
      "name": "FormField",
      "parent": 257,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-260"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", justifyContent: \"center\" }"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 261,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 261,
      "name": "FormField",
      "parent": 257,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-261"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 262,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 262,
      "name": "FormField",
      "parent": 257,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-262"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\", justifyContent: \"center\" }"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 263,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 263,
      "name": "FormField",
      "parent": 257,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-263"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 280,
      "void": false
    },
    {
      "from": null,
      "id": 264,
      "name": "div",
      "parent": 263,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-264"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 264,
      "void": false
    },
    {
      "from": null,
      "id": 265,
      "name": "div",
      "parent": 261,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-265"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 265,
      "void": false
    },
    {
      "from": null,
      "id": 266,
      "name": "div",
      "parent": 259,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-266"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 266,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 271,
      "name": "Input",
      "parent": 266,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-Input-271"
        },
        "value": {
          "type": "code",
          "value": "props.priceTotal"
        }
      },
      "seq": 271,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 272,
      "name": "Input",
      "parent": 265,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-Input-272"
        },
        "value": {
          "type": "code",
          "value": "props.priceClaimable"
        }
      },
      "seq": 272,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 273,
      "name": "Input",
      "parent": 264,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-Input-273"
        },
        "value": {
          "type": "code",
          "value": "props.priceNonClaimable"
        }
      },
      "seq": 273,
      "void": false
    },
    {
      "from": null,
      "id": 274,
      "name": "div",
      "parent": 258,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-274"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 274,
      "void": false
    },
    {
      "from": null,
      "id": 275,
      "name": "div",
      "parent": 260,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-275"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 275,
      "void": false
    },
    {
      "from": null,
      "id": 276,
      "name": "div",
      "parent": 262,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-div-276"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 276,
      "void": false
    },
    {
      "from": null,
      "id": 277,
      "name": "label",
      "parent": 274,
      "props": {
        "children": {
          "type": "value",
          "value": "ราคารวม",
          "valueEN": "Total price"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-label-277"
        }
      },
      "seq": 277,
      "void": false
    },
    {
      "from": null,
      "id": 278,
      "name": "label",
      "parent": 275,
      "props": {
        "children": {
          "type": "value",
          "value": "เบิกได้",
          "valueEN": "Claimable"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-label-278"
        }
      },
      "seq": 278,
      "void": false
    },
    {
      "from": null,
      "id": 279,
      "name": "label",
      "parent": 276,
      "props": {
        "children": {
          "type": "value",
          "value": "เบิกไม่ได้",
          "valueEN": "Non Claimable"
        },
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-label-279"
        }
      },
      "seq": 279,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 280,
      "name": "FormField",
      "parent": 257,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugOrderUX-FormField-280"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 258,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardDrugOrderUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "TH",
    "orderType": "ONE_DOSE",
    "selectedDrug": {
    },
    "showSearchResult": true
  },
  "width": 85
}

*********************************************************************************** */
